var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.selectedLogicType === 'skip_logic' ? 'Add Skip Logic' : 'Add Show and Hide Logic') + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close-dialog');
      }
    }
  }, [_c('XIcon')], 1)], 1), _c('v-card-subtitle', [_vm._v(" Personalize your form's experience based on people's responses ")]), _c('v-card-text', [_c('div', {
    staticClass: "logic-type-selector mb-4"
  }, [_c('f-select', {
    class: ['logic-type-selector__dropdown', ("logic-type-selector__dropdown--" + (_vm.selectedLogicType))],
    attrs: {
      "items": _vm.logicTypeOptions,
      "item-text": function (item) {
        return item.text;
      },
      "item-value": function (item) {
        return item.value;
      },
      "solo": "",
      "flat": "",
      "dense": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('span', [_vm._v(_vm._s(item.text))])];
      }
    }, {
      key: "item",
      fn: function (_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs,
          item = _ref2.item;
        return [_c('v-list-item', _vm._g(_vm._b({}, 'v-list-item', attrs, false), on), [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(item.text))])], 1), item.value === _vm.selectedLogicType ? _c('v-list-item-action', {
          staticStyle: {
            "padding-left": "32px",
            "min-width": "60px"
          }
        }, [_c('CheckIcon', {
          attrs: {
            "size": "16",
            "color": "var(--v-primary-base)"
          }
        })], 1) : _vm._e()], 1)];
      }
    }]),
    model: {
      value: _vm.selectedLogicType,
      callback: function ($$v) {
        _vm.selectedLogicType = $$v;
      },
      expression: "selectedLogicType"
    }
  })], 1), _vm.selectedLogicType === 'skip_logic' ? _c('SkipLogicEditor', {
    attrs: {
      "field-obj": _vm.getConditionalField,
      "field-const": _vm.getConditionalFieldConst,
      "field-location": _vm.allFieldsWithEnumeration[_vm.getCurrentConditionalFieldId].formattedLocation,
      "field-id": _vm.getCurrentConditionalFieldId,
      "initial-skip-logic": _vm.initialSkipLogic
    },
    on: {
      "update-skip-logic": _vm.updateSkipLogic
    }
  }) : _c('div', {
    staticClass: "conditional-logic-editor mt-4"
  }, [_c('v-text-field', {
    staticClass: "conditional-logic-editor__conditional-field",
    attrs: {
      "value": _vm.getConditionalField.title,
      "outlined": "",
      "disabled": "",
      "dense": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c(_vm.getConditionalFieldConst.ICON_COMPONENT, {
          tag: "component"
        }), _vm._v(" " + _vm._s(_vm.allFieldsWithEnumeration[_vm.getCurrentConditionalFieldId].formattedLocation) + " ")];
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "conditional-logic-editor__expression-wrapper"
  }, [_c(_vm.getConditionalFieldConst.CONDITIONAL_LOGIC.EXPRESSION_COMPONENT, {
    tag: "component",
    attrs: {
      "expression-obj": _vm.newFieldCondition.expression
    }
  })], 1), _c('div', {
    staticClass: "conditional-logic-editor__target-top-container"
  }, [_c('div', {
    staticClass: "conditional-logic-editor__target-action-wrapper"
  }, [_vm._v(" Then "), _c('ConditionalThenActionSelect', {
    attrs: {
      "target-obj": _vm.newFieldCondition.if_target,
      "actions": _vm.targetActions
    }
  })], 1), !_vm.elseTargetEnabled ? _c('span', {
    staticClass: "conditional-logic-editor__target-secondary-action",
    on: {
      "click": _vm.enableElseTarget
    }
  }, [_vm._v(" + Else Condition ")]) : _vm._e()]), _c('ConditionalTargetSelect', {
    attrs: {
      "condition-field-id": _vm.getCurrentConditionalFieldId,
      "target-obj": _vm.newFieldCondition.if_target,
      "another-targets": [].concat(_vm.newFieldCondition.else_target ? [_vm.newFieldCondition.else_target] : [])
    }
  }), _vm.elseTargetEnabled ? [_c('div', {
    staticClass: "conditional-logic-editor__target-top-container mt-4"
  }, [_c('div', {
    staticClass: "conditional-logic-editor__target-action-wrapper"
  }, [_vm._v(" Else "), _c('ConditionalThenActionSelect', {
    attrs: {
      "target-obj": _vm.newFieldCondition.else_target,
      "actions": _vm.targetActions
    }
  })], 1), _c('span', {
    staticClass: "conditional-logic-editor__target-secondary-action",
    on: {
      "click": _vm.disableElseTarget
    }
  }, [_c('Trash2Icon'), _vm._v(" Remove else ")], 1)]), _c('ConditionalTargetSelect', {
    attrs: {
      "condition-field-id": _vm.getCurrentConditionalFieldId,
      "target-obj": _vm.newFieldCondition.else_target,
      "another-targets": [].concat(_vm.newFieldCondition.if_target ? [_vm.newFieldCondition.if_target] : [])
    }
  })] : _vm._e()], 2)], 1), _c('v-card-actions', [_vm.hasActiveCondition ? _c('span', {
    staticClass: "conditional-logic-editor__target-secondary-action",
    on: {
      "click": function ($event) {
        _vm.removeConditionDialogModel = true;
      }
    }
  }, [_c('TrashIcon'), _vm._v(" Remove condition ")], 1) : _vm._e(), _c('v-dialog', {
    attrs: {
      "width": "600"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        var _vm$allFieldsWithEnum, _vm$getConditionalFie;
        return [_c('v-card', [_c('v-card-title', [_vm._v(" Delete logic "), _c('v-spacer'), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function ($event) {
              _vm.removeConditionDialogModel = false;
            }
          }
        }, [_c('XIcon')], 1)], 1), _c('v-card-text', [_c('div', {
          staticClass: "delete-logic-info"
        }, [_c('p', {
          staticClass: "mb-3"
        }, [_vm._v(" This question is being used as a destination in a " + _vm._s(_vm.selectedLogicType === 'skip_logic' ? 'skip logic' : 'conditional logic') + " from question "), _c('strong', [_vm._v(_vm._s((_vm$allFieldsWithEnum = _vm.allFieldsWithEnumeration[_vm.getCurrentConditionalFieldId]) === null || _vm$allFieldsWithEnum === void 0 ? void 0 : _vm$allFieldsWithEnum.formattedLocation) + ": " + _vm._s((_vm$getConditionalFie = _vm.getConditionalField) === null || _vm$getConditionalFie === void 0 ? void 0 : _vm$getConditionalFie.title))]), _vm._v(". If you remove it, that condition will be removed. The other rules of the logic will not be affected. ")]), _c('p', {
          staticClass: "mb-0"
        }, [_vm._v(" Do you want to continue? ")])])]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
          attrs: {
            "color": "gray_100",
            "rounded": ""
          },
          on: {
            "click": function ($event) {
              _vm.removeConditionDialogModel = false;
            }
          }
        }, [_vm._v(" Cancel ")]), _c('v-btn', {
          attrs: {
            "color": "red_400",
            "rounded": ""
          },
          on: {
            "click": function () {
              _vm.removeConditionDialogModel = false;
              _vm.removeCondition();
            }
          }
        }, [_vm._v(" Yes, delete ")])], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.removeConditionDialogModel,
      callback: function ($$v) {
        _vm.removeConditionDialogModel = $$v;
      },
      expression: "removeConditionDialogModel"
    }
  }), _c('v-spacer'), _c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "color": "gray_100",
      "rounded": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close-dialog');
      }
    }
  }, [_vm._v("Cancel ")]), _vm.getFieldCondition ? _c('div', {
    staticClass: "save-button-container"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": !_vm.saveButtonTooltip
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref3) {
        var on = _ref3.on,
          attrs = _ref3.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "blue_400",
            "rounded": "",
            "disabled": !_vm.isFormValid || !_vm.isCurrentConditionChanged
          },
          on: {
            "click": _vm.applyCondition
          }
        }, 'v-btn', attrs, false), on), [_vm._v("Save ")])];
      }
    }], null, false, 2439238297)
  }, [_c('span', [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": "",
      "color": "orange"
    }
  }, [_vm._v("mdi-alert")]), _vm._v(" " + _vm._s(_vm.saveButtonTooltip) + " ")], 1)])], 1) : _c('div', {
    staticClass: "save-button-container"
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": !_vm.saveButtonTooltip
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref4) {
        var on = _ref4.on,
          attrs = _ref4.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "blue_400",
            "rounded": "",
            "disabled": !_vm.isFormValid
          },
          on: {
            "click": _vm.applyCondition
          }
        }, 'v-btn', attrs, false), on), [_vm._v(_vm._s(_vm.selectedLogicType === 'skip_logic' ? 'Set Skip Logic' : 'Set Condition') + " ")])];
      }
    }])
  }, [_c('span', [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": "",
      "color": "orange"
    }
  }, [_vm._v("mdi-alert")]), _vm._v(" " + _vm._s(_vm.saveButtonTooltip) + " ")], 1)])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }